/**
 * Parse a string dollar amount to a float with at two decimal places.
 * @see https://stackoverflow.com/a/11832950
 **/
export const parseFloatToDollars = (value: string): number =>
  Math.round((parseFloat(value) + Number.EPSILON) * 100) / 100;
